import classNames from "classnames";
import { useTranslation } from "features/translations";
import React, { useRef } from "react";
import { Container, Heading3, Icon, SwiperLayout } from "shared/components";
import { useViewMode } from "shared/contexts/ViewMode";
import { SwiperSlide } from "swiper/react";

import { Item } from "./Item";
import styles from "./LayoutWidget015.module.scss";

export const LayoutWidget015 = ({ payload }) => {
  const title = payload?.title ?? "";
  const appearance = payload?.template ?? "light";
  const courses = payload?.items ?? [];

  const { t } = useTranslation();

  const prevRef = useRef(null);
  const nextRef = useRef(null);

  const { isDesktop } = useViewMode();

  return (
    <div className={classNames(styles.wrapper, styles[appearance])}>
      <Container className={styles.inner}>
        <div className={styles.header}>
          <Heading3 className={styles.title}>{t(title)}</Heading3>
          {courses.length > 0 && (
            <>
              {isDesktop && (
                <div className={styles["navigation-wrapper"]}>
                  <div className={styles["slider-navigation"]}>
                    <div
                      ref={prevRef}
                      className={classNames(
                        styles.navigation,
                        styles["navigation-prev"]
                      )}
                    >
                      <Icon className={styles.icon} name="arrow_slider_prev" />
                    </div>
                    <div
                      ref={nextRef}
                      className={classNames(
                        styles.navigation,
                        styles["navigation-next"]
                      )}
                    >
                      <Icon className={styles.icon} name="arrow_slider_next" />
                    </div>
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      </Container>
      <div className={styles.slider}>
        <SwiperLayout
          prevRef={prevRef}
          nextRef={nextRef}
          watchOverflow={false}
          slidesPerView={"auto"}
          spaceBetween={8}
          slidesPerGroup={1}
          slidesOffsetAfter={30}
        >
          {courses.map((item) => (
            <SwiperSlide key={item.id} className={styles.slide}>
              <Item appearance={appearance} {...item} />
            </SwiperSlide>
          ))}
        </SwiperLayout>
      </div>
    </div>
  );
};

export default LayoutWidget015;
